import { render, staticRenderFns } from "./how-to-bid-delivery.vue?vue&type=template&id=5214cf4a&"
import script from "./how-to-bid-delivery.vue?vue&type=script&lang=js&"
export * from "./how-to-bid-delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports